import type { FC, ReactElement } from 'react';
import { useAuth } from 'react-oidc-context';
import { Navigate, Outlet, useLocation } from 'react-router';
import { hasAnyRelevantRole, hasSomeRole, type Role } from '../utils/user';

export const PrivateRoute: FC<{ roles?: Role[]; children?: ReactElement }> = ({ roles, children }) => {
  const location = useLocation();
  const auth = useAuth();

  if (!auth.isAuthenticated || (roles ? !hasSomeRole(roles, auth.user) : !hasAnyRelevantRole(auth.user))) {
    return <Navigate to="/no-access" state={{ from: location }} replace />;
  }

  return children || <Outlet />;
};
